import React from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'

export class UserAware extends React.Component {
  render() {
    if (this.props.user) {
      return this.props.render(this.props.user)
    }
    return null
  }
}

UserAware.propTypes = {
  user: PropTypes.object,
  render: PropTypes.func.isRequired,
}

export default connect((store) => {
  return {
    user: store.user.record,
  }
})(UserAware)
